import React, { useState, useRef, useEffect } from 'react';
import { Card, CardBody } from 'reactstrap';
import AButton from '../../common/form-fields-mui/AButton';


import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { ReactComponent as UploadIcon } from "assets/img/svg/fi_upload.svg";
import { useHistory } from 'react-router-dom';
import APopover from '../../common/a-popover';
import ListComponent from './ListComponent';
import { getAllActiveProcessTag, getBulkLogsAudit, getDropdowns } from './apis';
import Filters from './Filters';
import { CONFIG_TYPE, getFilterFormFields, TEMPLATE_NAME } from './constant';
import { endpoint } from '../../common/constant';
import { fetchAllPostPromisedData, fetchAllPromisedData, fetchDeletePromisedData } from '../../common/utils/methods/commonMethods/utilityMethod';
import { processRowList } from '../../businessArea/component/FirstForm/constant';
import { updateRequest } from '../../edpOps/constant/common';
import { successToast } from '../../common/utils/methods/toasterFunctions/function';
import { CustomDragAndDrop } from '../../common/commonComponents';
import CustomBulkUploadDialog from './CustomBulkUploadDialog';
import ConfirmDeletionDialog from './ConfirmDeletionDialog';
import BulkAuditLogs from './BulkAuditLogs';

const ArpuWorkflow = () => {
    const history = useHistory();
    const [isBulkAuditOpenInfo, setBulkAuditOpenInfo] = useState()
    const [isBulkOpen, setBulkOpen] = useState();
    const [filterCount, setFilterCount] = useState()
    const [globalFilter, setGlobalFilter] = useState({})
    const [currentPage, setCurrentPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [currPageSize, setCurrentPageSize] = useState(50)
    const [rows, setRows] = useState([]);
    const ref = useRef()
    const [loader, setLoader] = useState(false)
    const [dropdowns, setDropdownsData] = useState({});
    const [files, setFiles] = useState();
    const [progressBarStatus, setProgressBarStatus] = useState(0);
    const [processTagId, setProcessTagId] = useState()
    const [openDeletion, setOpenDeletion] = useState(false)


    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        try {
            setLoader(true)
            const dropdown = await getDropdowns()
            searchArpuList({ dropdownList: dropdown })
            const processTag = await getAllActiveProcessTag(TEMPLATE_NAME)
            console.log("processTag", processTag)
            setProcessTagId(processTag?.id)
            setDropdownsData(dropdown)
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setLoader(false)
        }
    }
    const searchArpuList = async ({ dropdownList = dropdowns, request = {}, page = currentPage, pageSize = currPageSize }) => {
        try {
            setLoader(true)
            const url = `${endpoint.concessionConfigArpu.search}${CONFIG_TYPE}`
            const data = await fetchAllPostPromisedData(url, updateRequest({ ...request, pageNo: page, pageSize }))
            const rowList = processRowList(data?.data?.arpuMasterConfigDtoList, dropdownList)
            setRows(rowList ?? [])
            setRowCount(data?.data?.totalRecords)
            setCurrentPage(page)
            setCurrentPageSize(pageSize)
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setLoader(false)
        }
    }
    
    const createUpdateHandler = async (rowForm) => {
        try {
            setLoader(true);
            const reqObj = updateRequest({
                ...rowForm,
            })
            let url = `${endpoint.concessionConfigArpu.crud}${CONFIG_TYPE}`;
            let method = 'post';

            if (!rowForm?.isNew) {
                url = `${endpoint.concessionConfigArpu.crud}/${CONFIG_TYPE}`;
                method = 'put'
            }
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code === 200) {
                searchArpuList({})
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.log(err);
        }
        finally {
            setLoader(false)
        }
    }

    const deleteHandler = async (rowData) => {
        try {
            setLoader(true);
            const resp = await fetchDeletePromisedData(
                `${endpoint?.concessionConfigArpu.crud}/${rowData?.id}${CONFIG_TYPE}`
            );
            if (resp?.code === 200) {
                searchArpuList({})
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.error(err);
        }
        finally {
            setLoader(false)
        }
    };


    const handleFile = () => {

    }

    const handleBulkClose = () => {
        setBulkOpen(false);
        setFiles(null);
        setProgressBarStatus(0);
    }
    const handleBulkOpen = () => {
        setBulkOpen(true);
    }
    const handleOpenDeletion = (rowData) => {
        setOpenDeletion(rowData)
    }

    const bulkAuditHandler = async ({ page = isBulkAuditOpenInfo?.page, pageSize = isBulkAuditOpenInfo?.pageSize }) => {
        try {
            setLoader(true);
            const res = await getBulkLogsAudit({ page, pageSize })
            setBulkAuditOpenInfo({
                rows: res?.auditLogsEntityList,
                totalRecords: res?.totalRecords,
                page: page,
                pageSize: pageSize
            })
        }
        catch (err) {
            console.error(err)
        }
        finally {
            setLoader(false)
        }

    }

    return (
        <Card className='ml-3 mr-3'>
            <CardBody>

                <div className=" d-flex heading-4 color-dark align-items-center justify-content-between "
                //   style={headerStyle}
                >

                    <div className="">
                        <BackArrow className='mr-2 cursor' onClick={() => history.goBack()} />
                        <h3 className='d-inline'>ARPU Master Setup</h3>
                    </div>
                    <div className='d-flex align-items-start justify-content-center'>

                        <AButton
                            className="tiny-semi-bold color-dark"
                            onClick={handleBulkOpen}
                            size="sm"
                            updatedStyle={{
                                minWidth: "61px",
                            }}
                            variant="success_filled"
                        >
                            <span className='d-flex justify-content-center align-items-center' style={{ gap: '10px' }}>
                                <UploadIcon /> Bulk Upload Excel
                            </span>
                        </AButton>
                        <AButton
                            className="tiny-semi-bold color-dark"
                            onClick={() => { bulkAuditHandler({ page: 0, pageSize: 50 }) }}
                            size="sm"
                            updatedStyle={{
                                minWidth: "61px",
                            }}
                            variant="gray_filled"
                        >
                            <span className='d-flex justify-content-center align-items-center' style={{ gap: '10px' }}>
                                View Upload Logs
                            </span>
                        </AButton>

                        <APopover
                            buttonComponent={(openPopover, styles) => (
                                <AButton
                                    className="tiny-semi-bold color-dark"
                                    onClick={openPopover}
                                    variant='general'
                                    size="sm"
                                    updatedStyle={{
                                        minWidth: "61px",
                                        ...(filterCount > 0
                                            ? {
                                                border: "1px solid #00B0F5",
                                                color: "#00B0F5",
                                            }
                                            :
                                            styles),
                                    }}
                                >
                                    Filters
                                    {filterCount > 0 ? `(${filterCount})` : ""}
                                </AButton>
                            )}
                            menuComponent={(closePopup) =>
                                <Filters
                                    closePopup={closePopup}
                                    formFields={getFilterFormFields(dropdowns)}
                                    searchHandler={searchArpuList}
                                    filterCount={filterCount}
                                    setFilterCount={setFilterCount}
                                    globalFilter={globalFilter}
                                    setGlobalFilter={setGlobalFilter}
                                />
                            }
                        />
                        <AButton
                            className="tiny-semi-bold color-dark"
                            size="sm"
                            updatedStyle={{
                                minWidth: "61px",
                            }}
                            variant="primary_filled"
                        >
                            <span className='d-flex justify-content-center align-items-center'
                                style={{ gap: '10px' }}
                                onClick={() => ref.current.addNewRow()}
                            >
                                Add config
                            </span>
                        </AButton>

                    </div>
                </div>
                <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                <ListComponent
                    rows={rows}
                    ref={ref}
                    dropdowns={dropdowns}
                    createUpdateHandler={createUpdateHandler}
                    loader={loader}
                    setLoader={setLoader}
                    setDropdowns={setDropdownsData}
                    deleteHandler={handleOpenDeletion}
                    totalRecords={rowCount}
                    currentPageSize={currPageSize}
                    currentPage={currentPage}
                    searchArpuList={searchArpuList}
                />
                <CustomBulkUploadDialog
                    handleOpen={handleBulkOpen}
                    handleClose={handleBulkClose}
                    isBulkOpen={isBulkOpen}
                    files={files}
                    setFiles={setFiles}
                    setProgressBarStatus={setProgressBarStatus}
                    progressBarStatus={progressBarStatus}
                    searchArpuList={searchArpuList}
                    processTagId={processTagId}
                />
                <ConfirmDeletionDialog
                    open={openDeletion}
                    setOpen={setOpenDeletion}
                    onAgree={deleteHandler}
                />
                <BulkAuditLogs
                    rows={isBulkAuditOpenInfo?.rows}
                    currentPage={isBulkAuditOpenInfo?.page ?? 0}
                    currentPageSize={isBulkAuditOpenInfo?.pageSize ?? 0}
                    handleBulkClose={() => setBulkAuditOpenInfo(null)}
                    totalRecords={isBulkAuditOpenInfo?.totalRecords ?? 0}
                    isOpen={isBulkAuditOpenInfo}
                    bulkAuditHandler={bulkAuditHandler}
                />
            </CardBody>
        </Card>
    )
}

export default ArpuWorkflow;